import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const Footer = () => (
  <footer className="relative mt-24 overflow-hidden bg-ink text-ink-foreground">
    <div className="absolute inset-0 bg-mesh opacity-20" />
    <div className="container relative pt-20 pb-10">
      {/* Massive wordmark */}
      <Link to="/" className="block">
        <h2 className="font-display text-[18vw] font-bold leading-[0.85] tracking-tighter md:text-[14vw]">
          self<span className="font-serif-italic font-normal text-accent">educate</span>.
        </h2>
      </Link>

      <div className="mt-16 grid gap-10 border-t border-background/15 pt-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <p className="max-w-md text-base text-ink-foreground/70 text-pretty">
            Hub-ul central pentru auto-învățare. Materiale lucrate cu grijă, gândite ca să rămână cu tine.
          </p>
          <a
            href="mailto:selfeducate.ro@gmail.com"
            className="mt-6 inline-flex items-center gap-2 font-display text-2xl font-medium underline-offset-4 hover:underline"
          >
            selfeducate.ro@gmail.com <ArrowUpRight className="h-5 w-5" />
          </a>
        </div>

        <div>
          <h3 className="mb-4 font-mono text-xs uppercase tracking-widest text-ink-foreground/50">Învață</h3>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/subjects" className="text-ink-foreground/80 hover:text-accent">Toate materiile</Link></li>
            <li><Link to="/subjects/romanian" className="text-ink-foreground/80 hover:text-accent">Limba română</Link></li>
            <li><Link to="/materiale" className="text-ink-foreground/80 hover:text-accent">Bibliotecă (Resurse & Arhiva BAC)</Link></li>
            <li><Link to="/tutorials" className="text-ink-foreground/80 hover:text-accent">Tutoriale</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="mb-4 font-mono text-xs uppercase tracking-widest text-ink-foreground/50">Companie</h3>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/misiune" className="text-ink-foreground/80 hover:text-accent">Despre & Misiune</Link></li>
            <li><Link to="/pricing" className="text-ink-foreground/80 hover:text-accent">Abonament</Link></li>
            <li><Link to="/faq" className="text-ink-foreground/80 hover:text-accent">FAQ</Link></li>
            <li><Link to="/contact" className="text-ink-foreground/80 hover:text-accent">Contact & Sugestii</Link></li>
          </ul>
        </div>
      </div>

      <div className="mt-12 flex flex-col gap-4 border-t border-background/15 pt-6 text-xs font-mono uppercase tracking-widest text-ink-foreground/50 md:flex-row md:items-center md:justify-between">
        <span>© {new Date().getFullYear()} Self Educate</span>
        <nav className="flex flex-wrap gap-x-5 gap-y-2 normal-case tracking-normal">
          <Link to="/legal/termeni" className="hover:text-accent">Termeni și Condiții</Link>
          <Link to="/legal/confidentialitate" className="hover:text-accent">Confidențialitate</Link>
          <Link to="/legal/returnare" className="hover:text-accent">Returnare și Rambursare</Link>
        </nav>
        <span>FĂCUT ÎN ROMÂNIA · CU SUFLET</span>
      </div>
    </div>
  </footer>
);

export default Footer;
